import React, { useEffect, useState, useRef } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'https://api2b.pro';
const MIN_SPLASH_MS = 2000;

function getNormalizedHost() {
  return window.location.hostname.replace(/^www\./, '');
}

function Splash({ onSplashComplete }) {
  const [loaderLogo, setLoaderLogo] = useState(null);
  const [noSplash, setNoSplash] = useState(false);
  const [visible, setVisible] = useState(true);
  const mountTime = useRef(performance.now());

  // Fetch loader_logo from server API immediately
  useEffect(() => {
    const origin = getNormalizedHost();
    if (!origin) { setNoSplash(true); return; }

    const controller = new AbortController();

    fetch(
      `${API_URL}/api/logo?origin=${encodeURIComponent(origin)}`,
      { signal: controller.signal }
    )
      .then((res) => res.json())
      .then((data) => {
        const item = Array.isArray(data) ? data[0] : data;
        const path = item?.loader_logo;
        if (path) {
          setLoaderLogo(
            path.startsWith('http') ? path : `${API_URL}/storage/${path}`
          );
        } else {
          setNoSplash(true);
        }
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('Error fetching loader_logo:', err);
        }
        setNoSplash(true);
      });

    return () => controller.abort();
  }, []);

  // Once we know what to show, enforce minimum 2s then fade out
  useEffect(() => {
    if (!loaderLogo && !noSplash) return; // still waiting for API

    const elapsed = performance.now() - mountTime.current;
    const remaining = Math.max(0, MIN_SPLASH_MS - elapsed);

    let fadeTimer = null;
    const displayTimer = setTimeout(() => {
      const splashElement = document.querySelector('.splash-screen');
      if (splashElement) {
        splashElement.classList.add('fade-out');
      }

      fadeTimer = setTimeout(() => {
        setVisible(false);
        if (onSplashComplete) {
          onSplashComplete();
        }
      }, 500);
    }, remaining);

    return () => {
      clearTimeout(displayTimer);
      if (fadeTimer) clearTimeout(fadeTimer);
    };
  }, [loaderLogo, noSplash, onSplashComplete]);

  if (!visible) return null;

  // Show nothing until API responds — then show splash or dots
  if (!loaderLogo && !noSplash) {
    return <div className="splash-screen" />;
  }

  return (
    <div className="splash-screen">
      {loaderLogo ? (
        <img src={loaderLogo} alt="Loading..." />
      ) : (
        <div className="three-dots-loading">
          <span></span>
          <span></span>
          <span></span>
        </div>
      )}
    </div>
  );
}

export default Splash;
